import { useTranslation } from "react-i18next";
import { Form, Steps } from "@renderbus/ui";
import { FormInstance } from "antd";
import { IExportData } from "@/pages/export-list/types";
import styled from "styled-components";
import { AppealStatus } from "../constant";
import { dateFormatter } from "project-config/utils/date-formatter";
import { BillAppealProgressProps } from "../hooks/useAppealBill";
import FinishIcon from "@/assets/icons/consumption/finish";
import RevokeIcon from "@/assets/icons/consumption/revoke";
import TurnDownIcon from "@/assets/icons/consumption/turn-down";

export const AppealIconComponents = new Map([
  [
    AppealStatus.Finished,
    {
      icon: <FinishIcon />,
      color: "#13CB75",
    },
  ],
  [
    AppealStatus.Reject,
    {
      icon: <TurnDownIcon />,
      color: " #F3A126",
    },
  ],
  [
    AppealStatus.Withdraw,
    {
      icon: <RevokeIcon />,
      color: "",
    },
  ],
]);

export function AppealProgressForm({
  appealForm,
  billInfo,
  appealProgressList = [],
  currentStatus,
}: {
  appealForm: FormInstance;
  currentStatus?: number;
  billInfo?: IExportData;
  appealProgressList?: BillAppealProgressProps[];
}) {
  const { t } = useTranslation("center");

  return (
    <AppealProgressFormContainer>
      <Form
        form={appealForm}
        colon={false}
        layout="vertical"
        className="renderbus-ui--form appeal-form-progress"
        size="middle"
      >
        <Form.Item label={t("consumption_time_selector")} name="billCycle">
          {billInfo?.consumeDate}
        </Form.Item>
        <Form.Item label={t("consumption_label_bill_no")} name="billNo">
          {billInfo?.billNo}
        </Form.Item>
        <Form.Item
          label={t("consumption_label_bill_appeal_no")}
          name="appealBillNo"
        >
          {billInfo?.appealBillNo}
        </Form.Item>
      </Form>
      <Steps
        current={currentStatus || billInfo?.appealStatus}
        direction="vertical"
        items={appealProgressList.map((item) => {
          const { icon, color } = AppealIconComponents.get(
            item.appealStatus
          ) || {
            icon: "",
            color: "",
          };
          return {
            title: (
              <div style={{ color: color }}>
                {dateFormatter(Number(item.time))}
              </div>
            ),
            description: (
              <div style={{ color: color }}>
                {item.statisLabel}
                {item.appealResult && (
                  <AppealProgressStepsResult>
                    {item.appealStatus === AppealStatus.Reject &&
                      t("student_mod_identify_resason")}
                    {item.appealStatus === AppealStatus.Finished &&
                      t("consume_appeal_success_result")}
                    {item.appealResult}
                  </AppealProgressStepsResult>
                )}
              </div>
            ),
            icon: icon,
          };
        })}
      />
    </AppealProgressFormContainer>
  );
}

const AppealProgressFormContainer = styled.div`
  .appeal-form-progress {
    padding-bottom: 30px;
    .ant-form-item {
      margin-bottom: 18px;
    }
    .ant-form-item-label {
      padding-bottom: 0;
    }
  }
`;

const AppealProgressStepsResult = styled.div`
  margin-top: 6px;
  font-weight: 400;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  color: #d4d4d4;
`;
